module.exports = __webpack_public_path__ + "img/30.9211ca62.svg";